/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLetterHour: {
  name: 'letter-hour';
  data: string;
} = {
  name: 'letter-hour',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9.124 13.068v6.478H7V5h2.095v5.412h.135a3.086 3.086 0 0 1 1.172-1.4c.526-.345 1.212-.518 2.06-.518 1.122 0 2.024.346 2.706 1.037.686.691 1.03 1.717 1.03 3.075v6.94h-2.124v-6.684c0-.8-.206-1.42-.618-1.86-.412-.446-.985-.668-1.719-.668-.757 0-1.382.239-1.875.717-.492.474-.738 1.146-.738 2.017Z" fill="currentColor"/></svg>`,
};
